import { action } from "satcheljs";
import type { StateChangeSource } from "owa-left-pane-layout/lib/types/StateChangeSource";

export interface SetShowFolderPaneActionMessage {
    showFolderPane: boolean;
    stateChangeSource: StateChangeSource | undefined;
    newShowFolderPaneOverlayAsBlocking: boolean | undefined;
}

export const setShowFolderPane: (showFolderPane: boolean, stateChangeSource?: StateChangeSource, newShowFolderPaneOverlayAsBlocking?: boolean) => SetShowFolderPaneActionMessage = action("setShowFolderPane", function setShowFolderPane(showFolderPane: boolean, stateChangeSource?: StateChangeSource, newShowFolderPaneOverlayAsBlocking?: boolean): SetShowFolderPaneActionMessage {
    return {
        showFolderPane,
        stateChangeSource,
        newShowFolderPaneOverlayAsBlocking,
    };
});
